/** Generated for RijksSans at https://seek-oss.github.io/capsize/ */
export const fontMetrics = {
	unitsPerEm: 1000,
	capHeight: 656,
	ascent: 899,
	descent: -279,
	xHeight: 489,
} as const;
